import React from "react";
import { PieChart, Pie, Cell, Legend } from "recharts";
import { SIGNOL_COLOURS } from "@signolteam/shared/colours";
import { useManagerContext } from "@src/context/managerContext";
import { useDCContext } from "@src/context";
import ManagerHooks from "@src/context/hooks/managerHooks";
import { Loader, Tooltip } from "@src/components/atoms";
import { AppUtils, SignolUtils } from "@src/utils";
import PieChartLib from "@src/components/graphs/PieChart";
import { ManagersBehaviourChangeCard } from "@src/components/cards/manager";
import OpportunityCountsAndPieChartCard from "./PerformanceDataCountsAndPieChartCard";

/** Assumes its for the currently selected behaviour, and doesn't fetch its own data */
const PerformanceSuccessRateVsPreCard = ({
  isPendingBehaviourSuccessVsPre,
  currentBvrSuccessVsPre,
}) => {
  const { getDynamicReplacement } = useDCContext();
  const { selectedBehaviourColour } = useManagerContext();
  if (!currentBvrSuccessVsPre) return <></>;
  return (
    <ManagersBehaviourChangeCard
      isLoading={isPendingBehaviourSuccessVsPre}
      behaviourColour={selectedBehaviourColour.name}
      attributeText={getDynamicReplacement(
        "fuel_manager__behaviour__avg_success_card__title",
      )}
      preSignolText={getDynamicReplacement(
        "fuel_manager__behaviour__avg_success_card__pre_signol_text",
      )}
      postSignolValue={
        currentBvrSuccessVsPre?.avgSuccessRatePostSignolWeighted?.value
      }
      postSignolStandardError={
        currentBvrSuccessVsPre?.avgSuccessRatePostSignolWeighted
          ?.standardError95
      }
      changeVsPreValue={currentBvrSuccessVsPre?.avgSuccessRateChange?.value}
      changeVsPreStandardError={
        currentBvrSuccessVsPre?.avgSuccessRateChange?.standardError95
      }
      className="mb-6 xs:mr-6"
    />
  );
};
export default PerformanceSuccessRateVsPreCard;
